import { useId } from 'react';
import { sanitizeHTMLId } from 'src/utils';

export const useUniqueId = () => {
  const uniqueId = sanitizeHTMLId(useId());

  return { uniqueId };
};
